
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import {
  getOperDetails,
  updataOperMsgConfig,
  addOperMsgConfig
} from "@/api/api-basic";
import { optionKey, getOptionList } from "@/api/api-dict";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class AddOperMsgModel extends Vue {
  private isQuery = false;
  private modalTitle = i18n.t("oper.msgConfig");
  private modalShow = false;
  private tempNameObj: objAny = {
    "201": i18n.t("oper.201"),
    "203": i18n.t("oper.203"),
    "202": i18n.t("oper.202"),
    "301": i18n.t("oper.301"),
    "204": i18n.t("oper.204"),
    "101": i18n.t("oper.101"),
    "104": i18n.t("oper.104"),
    "102": i18n.t("oper.102"),
    "103": i18n.t("oper.103")
  };
  private wxBussTypeList: object = [];
  private ruleInline: objAny = {
    agent: [
      {
        required: true,
        message: i18n.t("oper.agentPl"),
        trigger: "change",
        type: "number"
      }
    ],
    signName: [
      {
        required: true,
        message: i18n.t("oper.signName"),
        trigger: "blur"
      }
    ],
    templateId: [
      {
        required: true,
        message: i18n.t("oper.please"),
        trigger: "blur"
      }
    ]
  };
  private formItem: objAny = {
    oprPkId: "",
    agent: 2,
    signName: "",
    accessKeyId: "",
    accessKeySecret: "",
    // smsInitCount: "",
    templateIds: [
      { bussType: "101", templateId: "", pkid: "", name: i18n.t("oper.101") },
      { bussType: "104", templateId: "", pkid: "", name: i18n.t("oper.104") },
      { bussType: "102", templateId: "", pkid: "", name: i18n.t("oper.102") },
      { bussType: "103", templateId: "", pkid: "", name: i18n.t("oper.103") },
      { bussType: "204", templateId: "", pkid: "", name: i18n.t("oper.204") },
      { bussType: "301", templateId: "", pkid: "", name: i18n.t("oper.301") },
      { bussType: "203", templateId: "", pkid: "", name: i18n.t("oper.203") }
    ]
  };
  private loading = false;
  private detailsData: objAny = {};

  public open(item: objAny) {
    this.modalShow = true;
    this.formItem.oprPkId = item.oprPkId;
    this.getOperDetails(item.oprPkId);
    this.getOptionList();
  }

  async getOperDetails(oprPkId: string): Promise<void> {
    const ret = await getOperDetails({ oprPkId: oprPkId });
    if (ret.status === this.$config.apiStatus) {
      const data = ret.data[0] || {};
      this.detailsData = data;
      this.init(data.smsConfigInfo);
    }
  }

  public handleSubmit(): Promise<objAny> {
    return new Promise<objAny>(resolve => {
      const formItem: objAny = this.$refs.formItem;
      formItem.validate((valid: boolean): void => {
        if (valid) {
          this.submitData();
        }
      });
    });
  }
  async submitData() {
    let ret: objAny;
    const json = {
      oprPkId: this.formItem.oprPkId,
      smsConfigParam: JSON.parse(JSON.stringify(this.formItem))
    };

    if (json.smsConfigParam.agent == 1) {
      json.smsConfigParam.templateIds = [];
    } else {
      json.smsConfigParam.templateIds = this.forTemplateIds(
        json.smsConfigParam.templateIds
      );
    }
    if (!this.detailsData.smsConfigInfo) {
      ret = await addOperMsgConfig(json);
    } else {
      ret = await updataOperMsgConfig(json);
    }
    if (ret.status === this.$config.apiStatus) {
      this.$emit("success");
      this.modalShow = false;
    } else {
      this.modalShow = true;
    }
  }
  public forTemplateIds(templateIds: object[]): object[] {
    const list: object[] = [];
    templateIds.map((item: objAny) => {
      if (item.templateId != "") {
        list.push(item);
      }
    });
    return list;
  }
  public init(data?: objAny) {
    this.formItem.templateIds.map((item: objAny) => {
      item.templateId = "";
      item.pkid = "";
    });
    if (!data) {
      this.formItem.agent = 1;
      this.formItem.signName = "";
    } else {
      this.formItem.agent = data.agent;
      this.formItem.signName = data.signName;
      this.formItem.accessKeyId = data.accessKeyId;
      this.formItem.accessKeySecret = data.accessKeySecret;
      if (data.templateIds && data.templateIds.length > 0) {
        this.formItem.templateIds.map((item: objAny) => {
          data.templateIds.map((tempItem: objAny) => {
            if (item.bussType == tempItem.bussType) {
              item.templateId = tempItem.templateId;
              item.pkid = tempItem.pkid;
            }
          });
        });
      }
    }
  }
  public closeModal(): void {
    this.modalShow = false;
  }
  async getOptionList(): Promise<void> {
    const ret = await getOptionList([optionKey.wxBussType]);
    this.wxBussTypeList = ret[optionKey.wxBussType];
  }
}
